import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
import InfoModal from "../InfoModal";
import SimpleCarousel from "../SimpleCarousel";
import BookServiceButton from "./BookServiceButton";
import {
  organizationsIntro,
  organizationServices,
  organizationPhotos,
} from "../../data/servicesContent";

const OrganizationsSection = () => {
  return (
    <div className="space-y-14">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-display text-3xl font-semibold text-[#21167D] mb-3">
          Organismes / Entreprises
        </h2>
        <p className="font-accent italic text-xl text-[#4A4458] mb-3">
          Des interventions sur mesure pour vos équipes et vos structures.
        </p>
        <p className="text-[#4A4458] leading-relaxed">{organizationsIntro}</p>
      </div>

      {/* Services proposés aux organismes (textes issus de la plaquette) */}
      <div className="grid md:grid-cols-3 gap-8">
        {organizationServices.map((service) => (
          <Card
            key={service.id}
            className="bg-[#FDFBF5] hover:shadow-xl transition-shadow"
          >
            <CardContent className="p-6 flex flex-col h-full">
              <h3 className="font-accent font-semibold text-lg text-[#21167D] mb-2">
                {service.title}
              </h3>
              <p className="text-[#4A4458] mb-6 leading-relaxed flex-1">{service.description}</p>
              <InfoModal
                triggerLabel="En savoir plus"
                triggerClassName="w-full"
                title={service.title}
              >
                <p>{service.description}</p>
                {service.details.map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </InfoModal>
              <BookServiceButton serviceId="intervention-organisme" className="w-full mt-3" />
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Carrousel photos */}
      <div>
        <h3 className="font-display text-2xl font-semibold text-[#21167D] mb-6 text-center">
          En images
        </h3>
        <div className="max-w-3xl mx-auto">
          <SimpleCarousel items={organizationPhotos} />
        </div>
      </div>

      <div className="text-center">
        <Link to="/contact">
          <Button size="lg" className="shadow-lg">
            Contactez-nous
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default OrganizationsSection;
